// formatAiFeedText.js — render lightweight **bold** markers in feed copy

function splitBoldSegments(text) {
  const source = String(text || '');
  if (!source.includes('**')) {
    return [{ bold: false, text: source }];
  }

  const segments = [];
  const parts = source.split('**');

  parts.forEach((part, index) => {
    if (!part) return;
    segments.push({
      bold: index % 2 === 1,
      text: part,
    });
  });

  return segments.length ? segments : [{ bold: false, text: source }];
}

export default splitBoldSegments;
